import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';
import { TextMedium } from '../../../components/common/text/TextMedium';

const Section = styled.section`
  margin: ${su(4, 0)};
`;

const Title = styled.h3`
  margin: ${su(2)} 0;

  ${(props) =>
    props.isNonActive &&
    css`
      color: ${theme.color.text_light};
    `}
`;

const Content = styled.div`
  position: relative;
`;

const ButtonCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${theme.color.mono_300};
  width: ${su(3)};
  height: ${su(3)};
  margin-inline-end: ${su(1)};
`;

const Button = styled.button`
  //margin: ${su(2)} 0; // we can't have modular margins because of animation
  width: 100%;
  height: ${su(6)};
  display: flex;
  align-items: center;
  line-height: 20px;
  color: ${theme.color.text_light};
  background: ${theme.color.mono_ex030};
  border-radius: ${theme.borderRadius.default};
  transition: transform ${motion.transition.micro_partial};

  &:hover {
    color: ${theme.color.text_light_hover};
    background-color: ${theme.color.mono_050};

    ${ButtonCircle} {
      background-color: ${theme.color.mono_300};
    }
  }
`;

export function AddCardButton(props) {
  return (
    <Button onClick={props.onClick}>
      <ButtonCircle>
        <Glyph
          size={theme.icon.size_small}
          source={glyph.core.plusMedium}
          color={theme.color.white}
        />
      </ButtonCircle>
      <TextMedium>{props.children}</TextMedium>
    </Button>
  );
}

export const flowCardTypes = {
  Section,
  Title,
  Content,
};
